import { useEffect, useState } from "react";
import { Language } from "../../../../context/LanguageContext";
import { translations } from "../../../../configs/translations";
import './Winner.css'
import { formatText } from "../../../../utils/formatText";

export interface WinnerProps {
    name: string;
}

export const Winner = ({ name }: WinnerProps) => {
    const [language, setLanguage] = useState<Language>('ru');
    const [isFinished, setIsFinished] = useState<boolean>(false);
    const t = translations[language];

    useEffect(() => {
        if (!isFinished) {
            setTimeout(() => {
                setIsFinished(true);
            }, 3000);
        }
    }, []);

    return (
        <div className="winner-container">
            <div className="winner-title-container">
                <h1 className={isFinished ? "winner-title slide-out-right" : "winner-title"}>{t.winner}</h1>
                <div className={isFinished ? "winner-name-container slide-out-left" : "winner-name-container"}>
                    <h2 className='winner-name'>
                        {formatText(name, 18)}
                    </h2>
                </div>
            </div>
        </div>
    )
}